export default __webpack_public_path__ + "7624d2a8a390b6bdff359a015fe7aff8.png";